import React from 'react';
import SheetGround from './SheetGround';
import { LoadingSpinner } from './LoadingSpinner';

interface SheetLoadingProps {
  text?: string;
  /* Defaults to covering the whole of <main>. Pass a shorter height only
     for a wait inside a page that has already drawn its chrome. */
  minHeight?: number | string;
  className?: string;
}

/* The wait, drawn on the sheet.

   A page that is loading is still the same sheet of paper, so it is ruled
   like one. Without this the wait fell through to the app's own body
   colour - a flat panel in the old palette - and every page switch flashed
   a surface that belongs to no design system before the real one arrived.

   The height once mattered as much as the colour: <main> was painted
   --aca-paper (#eeeae0, the superseded beige) under a min-h-screen, so a
   wait shorter than the viewport ended in a band of the very palette this
   component exists to stop showing. Layout now rules main as a SheetGround
   itself, so that band is gone whatever height is passed. 100vh is kept as
   the default because a wait should hold the page still rather than let the
   footer ride up under a spinner - it is now a matter of composure, not a
   patch over the ground beneath. */
const SheetLoading: React.FC<SheetLoadingProps> = ({
  text = 'Loading…',
  minHeight = '100vh',
  className,
}) => (
  <SheetGround
    className={className}
    style={{
      minHeight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
    }}
  >
    <LoadingSpinner size="lg" text={text} />
  </SheetGround>
);

export default SheetLoading;
